import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import Link from 'Elements/Link';
import WeekCalendar from 'Elements/WeekCalendar';
import Arrow from 'Elements/Link/Arrow';

export const Container = styled.article`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column-reverse;
        position: relative;
        align-items: center;

        @media ${theme.breakpoints.medium.media} {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    `}
`;

export const ImageContainer = styled.div`
    ${({ theme }) => css`
        place-items: center;
        position: relative;
        height: 100%;
        width: 100%;

        &:before {
            content: '';
            background: ${theme.colors.primaryContrast.hex};
            border-radius: 0.5rem 0.5rem 0 0;
            width: 100%;
            height: 40%;
            position: absolute;
            bottom: 0;
            left: 0;
        }

        @media ${theme.breakpoints.medium.media} {
            &:before {
                display: none;
            }
        }
    `}
`;

export const ImageLink = styled(Link)`
    ${({ theme }) => css`
        display: block;
        width: 90%;
        height: 12.25rem;
        border-radius: 0.5rem;
        overflow: hidden;

        @media ${theme.breakpoints.medium.media} {
            height: 18.5rem;
            width: 100%;
        }

        @media ${theme.breakpoints.large.media} {
            height: 22.5rem;
        }
    `}
`;

export const ImageWrapper = styled(animated.div)`
    height: 100%;
    width: 100%;
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        background-color: ${theme.colors.primaryContrast.hex};
        border-radius: 0 0 0.5rem 0.5rem;
        display: flex;
        flex-direction: column;
        align-self: center;
        padding: 1rem;
        width: 100%;

        @media ${theme.breakpoints.medium.media} {
            width: 104%;
            border-radius: 0.5rem;
            z-index: 2;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1.5rem;
        }
    `}
`;

export const StyledWeekCalendar = styled(WeekCalendar)`
    ${({ theme }) => css`
        svg {
            width: 3.5rem;
            height: 3.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            display: inline-block;
            height: 5.5rem;

            svg {
                width: 5rem;
                height: 5.5rem;
            }
        }
    `}
`;

export const WeekStatus = styled.p<{ $weekStatusColour: string }>`
    ${({ theme, $weekStatusColour }) => css`
        width: fit-content;
        margin: 0;
        color: ${$weekStatusColour};
        background-color: ${$weekStatusColour === '#197A6E'
            ? '#E9F5F3'
            : $weekStatusColour === '#B2000E'
            ? '#FAE8E9'
            : $weekStatusColour === '#7536C3'
            ? '#F4ECFE'
            : theme.colors.secondary.hex};
        padding: 0 0.5rem;
        border-radius: 1.125rem;
        font-size: 0.875rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1rem;
        }
    `}
`;

export const HeadingWrapper = styled.div`
    display: flex;
    gap: 0.5rem;
    margin: 0;
    align-items: center;
`;

export const CardLink = styled(Link)`
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    text-decoration: none;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
    }
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.375rem;
        color: ${theme.colors.text.hex};
        margin: 0.25rem 0 0 0;
        line-height: 1.35rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0;
            line-height: 1.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.75rem;
            line-height: 1.85rem;
        }
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.text.hex};
        margin: 1rem 0 1.5rem 0;

        @media ${theme.breakpoints.medium.media} {
            margin: 0.5rem 0;
        }

        @media ${theme.breakpoints.large.media} {
            margin: 0.75rem 0 0.8rem 0;
        }
    `}
`;

export const StyledArrowLink = styled(Arrow)`
    ${({ theme }) => css`
        align-self: end;

        span {
            background: transparent;
        }

        svg {
            color: ${theme.colors.primary.hex};
        }
    `}
`;
